import "./headers";

jQuery(document).ready(function($) {
  $(".backplate").click(function() {
    $(".menu-tendina").removeClass("menu-tendina--active");
    $(".o-popup").removeClass("o-popup--open");
    $(".hamburger").removeClass("is-active");
    $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
    $(".btn-nav").removeClass("btn-nav--active");
    $(this).removeClass("backplate--open");
  });
});
